/* Hive hero scenes: draws the smoke textures once, then keeps animation off for scenes that
   are not on screen. The smoke canvases are never redrawn after the first paint, so window
   resizes and slide changes only move and scale finished GPU layers. */
(function () {
  if (window.__hiveScenes) return;
  window.__hiveScenes = true;

  var idle = window.requestIdleCallback || function (cb) { return setTimeout(function () { cb({ timeRemaining: function () { return 8; } }); }, 1); };

  /* fine film grain: one 128px tile made once and shared by every scene */
  try {
    var g = document.createElement('canvas');
    g.width = g.height = 128;
    var gx = g.getContext('2d');
    var px = gx.createImageData(128, 128);
    for (var i = 0; i < px.data.length; i += 4) {
      var v = Math.random();
      var c = v > 0.5 ? 255 : 0;
      px.data[i] = px.data[i + 1] = px.data[i + 2] = c;
      px.data[i + 3] = Math.round(Math.abs(v - 0.5) * 2 * 34);
    }
    gx.putImageData(px, 0, 0);
    document.documentElement.style.setProperty('--hs-grain-tile', 'url(' + g.toDataURL('image/png') + ')');
  } catch (e) {}

  /* one smoke layer: render the noise filter at the canvas's fixed size, once */
  function bake(cv, done) {
    var p = (cv.getAttribute('data-hs-tex') || '').split('|');
    if (p.length < 5) return done();
    var w = cv.width, h = cv.height;
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="' + h + '" viewBox="0 0 1600 900" preserveAspectRatio="none">' +
      '<filter id="f" x="0" y="0" width="100%" height="100%"><feTurbulence type="fractalNoise" baseFrequency="' + p[0] + '" numOctaves="' + p[1] + '" seed="' + p[2] + '"' + (p[4] === '1' ? ' stitchTiles="stitch"' : '') + '/>' +
      '<feColorMatrix values="' + p[3] + '"/></filter><rect width="1600" height="900" filter="url(#f)"/></svg>';
    var img = new Image();
    img.decoding = 'async';
    img.onload = function () {
      try {
        cv.getContext('2d').drawImage(img, 0, 0, w, h);
        var twin = cv.parentNode && cv.parentNode.querySelector('canvas[data-hs-copy]');
        if (twin) { twin.getContext('2d').drawImage(cv, 0, 0); twin.classList.add('is-baked'); }
        cv.classList.add('is-baked');
      } catch (e) {}
      done();
    };
    img.onerror = function () { done(); };
    img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }

  /* queue: on-screen scenes first, one layer per idle slot so the page never stalls */
  var queue = [], running = false;
  function pump() {
    if (running || !queue.length) return;
    running = true;
    idle(function () {
      var cv = queue.shift();
      cv.__hsStarted = true;
      bake(cv, function () { running = false; pump(); });
    }, { timeout: 400 });
  }
  function enqueue(cv, urgent) {
    if (cv.classList.contains('is-baked')) return;
    var at = queue.indexOf(cv);
    if (at > -1) { if (!urgent) return; queue.splice(at, 1); }
    else if (cv.__hsStarted) return;
    urgent ? queue.unshift(cv) : queue.push(cv);
    pump();
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var on = en.isIntersecting;
      en.target.classList.toggle('hs-paused', !on);
      if (on) en.target.querySelectorAll('canvas[data-hs-tex]').forEach(function (cv) { enqueue(cv, true); });
    });
  }, { rootMargin: '0px 25% 0px 25%' }) : null;

  /* Keep the current slide pinned while the window is resized. A ResizeObserver runs after
     layout and before paint, so the slide is corrected in the same frame: no one-frame jump
     and no smooth-scroll catch-up ('instant' ignores CSS scroll-behavior: smooth). */
  function pinSlider(slider) {
    if (slider.__hsPin || !('ResizeObserver' in window)) return;
    slider.__hsPin = true;
    var lastW = slider.clientWidth, idx = 0, resizing = 0;
    slider.addEventListener('scroll', function () {
      if (resizing || !lastW) return;
      idx = Math.round(slider.scrollLeft / lastW);
    }, { passive: true });
    new ResizeObserver(function () {
      var w = slider.clientWidth;
      if (!w || w === lastW) return;
      lastW = w;
      clearTimeout(resizing);
      resizing = setTimeout(function () { resizing = 0; }, 200);
      slider.scrollTo({ left: Math.round(w * idx), behavior: 'instant' });
    }).observe(slider);
  }

  function init(root) {
    (root || document).querySelectorAll('.hive-scene').forEach(function (scene) {
      var slider = scene.closest('.slider');
      if (slider) pinSlider(slider);
      if (scene.__hsInit) return;
      scene.__hsInit = true;
      if (io) io.observe(scene);
      scene.querySelectorAll('canvas[data-hs-tex]').forEach(function (cv) { enqueue(cv, false); });
    });
  }

  /* Have every slide's images downloaded and decoded before the slider reaches them, so a
     slide change never waits on a network request or a main-thread image decode. Runs only
     after the page has finished loading, so it never competes with the first slide. */
  function warmSlides() {
    document.querySelectorAll('slideshow-component .slider img').forEach(function (img) {
      img.decoding = 'async';
      if (img.loading === 'lazy') img.loading = 'eager';
      if (img.decode) img.decode().catch(function () {});
    });
  }
  if (document.readyState === 'complete') idle(warmSlides, { timeout: 2000 });
  else window.addEventListener('load', function () { idle(warmSlides, { timeout: 2000 }); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
